module.exports = __webpack_public_path__ + "static/media/basecamp.a5f6da15.png";